<template>
  <component :is="component" class="ui-button">
    <slot />
  </component>
</template>

<script>

export default {
  props: {
    component: {
      type: String,
      default: 'a'
    }
  }
}
</script>

<style>
.ui-button {
  text-decoration: none;
  color: #000;
  background: #fff;
  padding: 15px 40px;
  letter-spacing: 0.3em;
  font-size: 12px;
  font-weight: bolder;
  transition: all 0.1s ease-in-out;
  border: 2px solid #000;
  display: inline-block;
}
.ui-button:hover {
  color: #fff;
  background: #000;
}
</style>



// WEBPACK FOOTER //
// UiButton.vue?1044a190